import type { CharacterSave } from '../../game/character';

/**
 * Titles are stored by display name in `char.titles` (so nameplates can show
 * `char.title` directly). Roster-wide sources (achievements, journals) are
 * merged in when the Titles tab is opened.
 */

export function addTitle(c: CharacterSave, title: string): boolean {
  if (c.titles.includes(title)) return false;
  c.titles.push(title);
  return true;
}

/** Equips a title the character owns (null clears it). */
export function setActiveTitle(c: CharacterSave, title: string | null): boolean {
  if (title !== null && !c.titles.includes(title)) return false;
  c.title = title;
  return true;
}
